import { take } from 'rxjs/operators'
import MainService from '@services/main/main.service'
import LogService from '@services/log/log.service'
import onEnvironmentChange from '@/observables/environment.observable'
import Environment from '@interfaces/environment.interface'
import Category from '@/interfaces/category.interface'
import Country from '@interfaces/country.interface'
import { AxiosResponse } from 'axios'

export default class GeneralListingsService extends MainService {
  url: string
  logService = new LogService()

  constructor(apiUrl?: string) {
    super()
    if (!apiUrl) {
      onEnvironmentChange.pipe(take(1)).subscribe((environment: Environment) => {
        this.url = environment?.squidApis?.generalListings
      })
    } else {
      this.url = apiUrl
    }
    this.logService.init('General Listings Service')
  }

  async getRaces() {
    return await fetch(`${this.url}/races`, {
      method: 'GET',
    })
      .then((response) => response.json())
      .catch((error) => {
        throw error
      })
  }

  async getGenders() {
    return await fetch(`${this.url}/genders`, {
      method: 'GET',
    })
      .then((response) => response.json())
      .catch((error) => {
        throw error
      })
  }

  async getCategoriesWithChildren(expand = 'children'): Promise<Category[]> {
    return await fetch(`${this.url}/profile-categories/parents?expand=${expand}`, {
      method: 'GET',
    })
      .then((response) => response.json())
      .catch((error) => {
        throw error
      })
  }

  async getOnlyParentCategories(): Promise<Category[]> {
    return await fetch(`${this.url}/profile-categories`, {
      method: 'GET',
    })
      .then((response) => response.json())
      .catch((error) => {
        throw error
      })
  }

  public async getCountries(lang = 'br'): Promise<Array<Country>> {
    return await this.http
      .get(`${this.url}/countries?lang=${lang || 'br'}`)
      .then(
        (r: AxiosResponse) =>
          r.data.sort((a: Country, b: Country) => a.name.localeCompare(b.name, lang || 'en', { sensitivity: 'base' })) || []
      )
      .catch((error) => {
        throw error
      })
  }
}
